module.exports = __webpack_public_path__ + "static/media/lactating-mothers-UNFPA.43bf30bb.jpg";